import axios from "axios";

const endpoint = process.env.REACT_APP_ENDPOINT || 'http://localhost:7071/api';

export const get = (path: string, payload?: any) => {
    let params = '';
    if (Object.keys(payload ?? {}).length > 0) {
        params = '?';
        Object.keys(payload).forEach((key) => {
            params += `${key}=${payload[key]}&`;
        });
        params = params.substring(0, params.length - 1);
    }
    return axios.get(`${endpoint}${path}${params}`);
};

export const post = (path: string, payload: any) => axios.post(`${endpoint}${path}`, payload);
export const postMulti = (path: string, data: FormData) => fetch(
    `${endpoint}${path}`,
    {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('ID_TOKEN')}`,
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_OCP_APIM_SUB_KEY ?? '',
        },
        body: data,
    },
);

export const patch = (path: string, payload: any) => axios.patch(`${endpoint}${path}`, payload);

export const del = (path: string) => axios.delete(`${endpoint}${path}`);

const request = (dispatch: any, type: string, payload: any) => {
     
    if (payload.onSuccess) delete payload.onSuccess;

    dispatch({
        type,
        payload,
    });
};

export default request;
